import { render } from "./UserBindView.vue?vue&type=template&id=64885f7b&scoped=true&ts=true"
import script from "./UserBindView.vue?vue&type=script&lang=ts"
export * from "./UserBindView.vue?vue&type=script&lang=ts"

import "./UserBindView.vue?vue&type=style&index=0&id=64885f7b&lang=less&scoped=true"
import "./UserBindView.vue?vue&type=style&index=1&id=64885f7b&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64885f7b"]])

export default __exports__